// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from 'react';
import { PlasmicProfileGallery, DefaultProfileGalleryProps } from './plasmic/paziresh_24_profile/PlasmicProfileGallery';
import { HTMLElementRefOf } from '@plasmicapp/react-web';

export interface ProfileGalleryProps extends DefaultProfileGalleryProps {
  /** Passed through to Gallery code component for accessible alts. */
  imageAltPrefix?: string;
}

function ProfileGallery_(props: ProfileGalleryProps, ref: HTMLElementRefOf<'div'>) {
  const { imageAltPrefix, ...rest } = props;

  return (
    <PlasmicProfileGallery
      root={{ ref }}
      paizresh24Gallery={{
        eagerFirst: true,
        imageAltPrefix: imageAltPrefix?.trim() || 'تصویر گالری پزشک',
      }}
      {...rest}
    />
  );
}

const ProfileGallery = React.forwardRef(ProfileGallery_);
export default ProfileGallery;
